export const SORT_ORDER = {
  ASC: 'ASC',
  DESC: 'DESC',
};
